/**
 * Shared portfolio-inventory vocabulary — the single source of truth for the
 * sort keys and sort direction used by BOTH the wire contract
 * (`common/contracts/portfolio.ts` derives its Zod enums from these) and the
 * server inventory query (`server/db/uploads/portfolio-inventory.ts` keyset-
 * paginates by them). Defined in `common/` so neither side hand-lists the values
 * and the two cannot drift.
 *
 * Only columns that map to a single, reliably-collated scalar are sortable.
 * Date/text columns (origination date, latest transaction date) are deliberately
 * excluded: their stored value is the customer's raw string with no dependable
 * ordering.
 */

export const PORTFOLIO_SORT_KEYS = [
  'loan_id',
  'original_amount',
  'fico',
  'interest_rate',
  'current_balance',
  'snapshots',
  'transactions',
  // F123: the "Transactions" secondary is a sign-blind SUM of mixed transaction amounts
  // (charge-off + recovery + payoff + prepayment + unscheduled), not a charge-off total —
  // named honestly `transaction_flow_total` end-to-end (was: `charge_off_total`).
  'transaction_flow_total',
] as const;
export type PortfolioSortKey = (typeof PORTFOLIO_SORT_KEYS)[number];

export const PORTFOLIO_SORT_DIRECTIONS = ['asc', 'desc'] as const;
export type PortfolioSortDirection = (typeof PORTFOLIO_SORT_DIRECTIONS)[number];
